import React from 'react';

import Icon from '../Icon';

export const VibrationIntensityLowIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 32 32' fill='none' {...props}>
            <path
                d='M6.40041 14.5781H5.6893C5.49293 14.5781 5.33374 14.7373 5.33374 14.9337V17.067C5.33374 17.2634 5.49293 17.4226 5.6893 17.4226H6.40041C6.59677 17.4226 6.75596 17.2634 6.75596 17.067V14.9337C6.75596 14.7373 6.59677 14.5781 6.40041 14.5781Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M26.3115 14.5781H25.6004C25.4041 14.5781 25.2449 14.7373 25.2449 14.9337V17.067C25.2449 17.2634 25.4041 17.4226 25.6004 17.4226H26.3115C26.5079 17.4226 26.6671 17.2634 26.6671 17.067V14.9337C26.6671 14.7373 26.5079 14.5781 26.3115 14.5781Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M11.3782 12.4448H10.6671C10.4707 12.4448 10.3115 12.604 10.3115 12.8004V19.2004C10.3115 19.3967 10.4707 19.5559 10.6671 19.5559H11.3782C11.5746 19.5559 11.7337 19.3967 11.7337 19.2004V12.8004C11.7337 12.604 11.5746 12.4448 11.3782 12.4448Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M21.3338 12.4448H20.6226C20.4263 12.4448 20.2671 12.604 20.2671 12.8004V19.2004C20.2671 19.3967 20.4263 19.5559 20.6226 19.5559H21.3338C21.5301 19.5559 21.6893 19.3967 21.6893 19.2004V12.8004C21.6893 12.604 21.5301 12.4448 21.3338 12.4448Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
            <path
                d='M16.356 5.3335H15.6449C15.4485 5.3335 15.2893 5.49268 15.2893 5.68905V26.3113C15.2893 26.5076 15.4485 26.6668 15.6449 26.6668H16.356C16.5523 26.6668 16.7115 26.5076 16.7115 26.3113V5.68905C16.7115 5.49268 16.5523 5.3335 16.356 5.3335Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
        </Icon>
    );
};
